import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Province } from './province.model';
import provinceService from './province.service';

// namespace
export const PROVINCE_STORE_NAMESPACE = 'provinceStore';

// state
interface ProvinceState {
  provinces: Province[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: ProvinceState = {
  provinces: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<ProvinceState> = {
  [mutationConstant.FETCH]: (state: ProvinceState, provinces: Province[]) => {
    state.provinces = provinces;
  },
  [mutationConstant.PENDING]: (state: ProvinceState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: ProvinceState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: ProvinceState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<ProvinceState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<ProvinceState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      provinceService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<ProvinceState, RootState> = {
  [getterConstant.ALL]: (state: ProvinceState) => state.provinces,
  [getterConstant.BY_ID]: (state: ProvinceState) => (id: number) => state.provinces.find(m => m.id === id),
  [getterConstant.STATUS]: (state: ProvinceState) => state.status,
};

// module
const module: Module<ProvinceState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const ProvinceGetter = {
  ALL: `${PROVINCE_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${PROVINCE_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${PROVINCE_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const ProvinceAction = {
  FETCH: `${PROVINCE_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
